// ==========================================
// WIDGET 1: Fiber Calculator (AJAX Variant Version)
// Date: 4/10/2026
// ==========================================
document.addEventListener("DOMContentLoaded", function() {
  var container = document.getElementById("jacks-fiber-calculator-target");
  if (!container) return;

  var widgetHTML = `
    <style>
      #fiber-calc-widget {
        background-color: #f4f6f8; border: 1px solid #dcdcdc; border-radius: 8px;
        padding: 20px; margin: 20px 0; font-family: inherit; max-width: 550px;
      }
      #fiber-calc-widget h3 { margin-top: 0; color: #003366; font-size: 1.25em; margin-bottom: 15px; }
      .calc-form-group { margin-bottom: 15px; }
      .calc-form-group label { display: block; font-weight: bold; margin-bottom: 5px; color: #333; }
      .calc-form-group select, .calc-form-group input {
        width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box;
      }
      .input-helper {
        font-size: 0.85em; color: #666; margin-top: 4px; font-style: italic;
        background-color: #fffbe6; padding: 5px; border: 1px solid #efe8b1; border-radius: 3px; display: none;
      }
      #calc-results-box {
        background-color: #fff; border-left: 6px solid #0088cc; padding: 15px; margin-top: 15px;
        display: none; box-shadow: 0 2px 5px rgba(0,0,0,0.05);
      }
      .result-highlight {
        font-weight: bold; color: #003366; font-size: 1.2em; margin-bottom: 10px;
        border-bottom: 1px solid #eee; padding-bottom: 5px;
      }
      .recommendation-box { background-color: #eef9ff; padding: 10px; border-radius: 5px; margin-bottom: 10px; }
      .rec-title { font-weight: bold; color: #d63031; margin-bottom: 8px; display: block; }
      
      .buy-btn-ajax {
        display: block; width: 100%; background-color: #0088cc; color: white !important;
        text-align: center; border: none; padding: 12px 15px; border-radius: 4px;
        font-size: 1em; margin-bottom: 5px; font-weight: bold; cursor: pointer;
        transition: background-color 0.2s;
      }
      .buy-btn-ajax:hover { background-color: #005f8f; }
      .buy-btn-ajax:disabled { background-color: #7abfe4; cursor: not-allowed; }
      .buy-btn-success { background-color: #00A650 !important; }
      
      .result-note { font-size: 0.85em; color: #555; margin-top: 10px; line-height: 1.4; }
      #usage-guide-box { margin-top: 15px; padding-top: 10px; border-top: 1px dashed #ccc; }
      .usage-title { font-weight: bold; color: #333; display: block; margin-bottom: 5px; }
    </style>

    <div id="fiber-calc-widget">
      <h3>Need to figure out how much you need?</h3>
      <p style="margin-bottom:15px; font-size:0.95em;">Use this handy calculator to find the exact dosage and bag combination for your filter.</p>
      <div class="calc-form-group">
        <label for="filter-type">Choose your Filter Type:</label>
        <select id="filter-type">
          <option value="">-- Select Filter --</option>
          <option value="de">DE Filter (Full Replacement)</option>
          <option value="cartridge">Cartridge Filter (Enhancer)</option>
          <option value="sand">Sand Filter (Enhancer)</option>
        </select>
      </div>
      <div class="calc-form-group" id="sqft-group" style="display:none;">
        <label for="filter-sqft">Total Square Feet of Filter Area:</label>
        <input type="number" id="filter-sqft" placeholder="e.g. 60 or 420">
        <div id="cartridge-helper" class="input-helper">
          <strong>Tip:</strong> If your filter has multiple cartridges (e.g. 4), add them all together (e.g. 4 x 100 = 400 sq ft).
        </div>
      </div>
      <div id="calc-results-box">
        <div id="calc-output-text"></div>
        <div id="usage-guide-box">
          <span class="usage-title">When to replace the fiber?</span>
          <span id="usage-guide-text" style="font-size:0.9em; color:#444;"></span>
        </div>
      </div>
    </div>
  `;

  container.innerHTML = widgetHTML;

  var typeSelect = document.getElementById('filter-type');
  var sqftInput = document.getElementById('filter-sqft');
  var analyticsTimer; 

  function calculateFiberDosage() {
    var type = typeSelect.value;
    var sqftVal = sqftInput.value;
    var sqftGroup = document.getElementById('sqft-group');
    var resultBox = document.getElementById('calc-results-box');
    var outputDiv = document.getElementById('calc-output-text');
    var usageText = document.getElementById('usage-guide-text');
    var cartHelper = document.getElementById('cartridge-helper');
    
    // Shopify Variant IDs
    var varId9oz = 54030505574675; 
    var varId18oz = 54030505509139;
    var varId36oz = 54030505541907;

    resultBox.style.display = 'none';
    sqftGroup.style.display = 'none';
    cartHelper.style.display = 'none';
    clearTimeout(analyticsTimer);

    if (!type) return;

    if (type === 'sand') {
      resultBox.style.display = 'block';
      outputDiv.innerHTML = `
        <div class="result-highlight">Dosage Cap: 9 oz Total</div>
        <div class="recommendation-box">
          <span class="rec-title">Recommended Purchase:</span>
          <button class="buy-btn-ajax" onclick="addBundleToCart([{id: ${varId9oz}, quantity: 1}], this)">Add 1x 9oz Bag to Cart</button>
        </div>
        <p class="result-note"><strong>Instructions:</strong> Add <strong>3 oz</strong> (by weight) at a time through the skimmer. <strong>Max 9 oz total.</strong></p>
      `;
      usageText.innerHTML = "<strong>24 Hours Max.</strong> Since this sits on top of your sand to polish the water, you must backwash the filter after 24 hours of continuous running.";
      if (typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent('Jacks Magic Fiber', type, 'N/A');
      return; 
    }

    sqftGroup.style.display = 'block';
    if (type === 'cartridge') cartHelper.style.display = 'block';

    if (sqftVal > 0) {
      resultBox.style.display = 'block';
      var totalOz = 0;
      var noteText = "";

      if (type === 'de') {
        var scoops = (sqftVal / 12); 
        totalOz = Math.ceil(scoops * 7);
        noteText = `<p class="result-note"><strong>Dosing:</strong> Approx ${scoops.toFixed(1)} standard DE Scoops (1 Scoop vol = 7oz weight). <br><em>This completely replaces DE powder.</em></p>`;
        usageText.innerHTML = "<strong>Watch your Pressure Gauge.</strong> Backwash and recharge when pressure rises 8-10 PSI above your starting 'clean' pressure.";
      } 
      else if (type === 'cartridge') {
        totalOz = Math.ceil((sqftVal / 25) * 3);
        noteText = `<p class="result-note"><em>Note: Use on TOP of existing cartridge to enhance filtration.</em></p>`;
        usageText.innerHTML = "<strong>Watch your Pressure Gauge.</strong> Clean cartridges when pressure rises 8-10 PSI above starting pressure. <br><em>Benefit: The fiber coats the cartridge, so dirt washes off easily!</em>";
      }

      // Optimization Logic
      var rem = totalOz;
      var bags36 = Math.floor(rem / 36); rem = rem % 36;
      var bags18 = Math.floor(rem / 18); rem = rem % 18;
      var bags9 = Math.ceil(rem / 9);

      if (bags9 === 2) { bags18++; bags9 = 0; }
      if (bags18 === 2) { bags36++; bags18 = 0; }

      // Build the Array of items for the Cart API
      var cartItems = [];
      var buttonTextArray = [];
      
      if (bags36 > 0) { cartItems.push(`{id: ${varId36oz}, quantity: ${bags36}}`); buttonTextArray.push(`${bags36}x 36oz`); }
      if (bags18 > 0) { cartItems.push(`{id: ${varId18oz}, quantity: ${bags18}}`); buttonTextArray.push(`${bags18}x 18oz`); }
      if (bags9 > 0)  { cartItems.push(`{id: ${varId9oz}, quantity: ${bags9}}`); buttonTextArray.push(`${bags9}x 9oz`); }

      var itemsString = "[" + cartItems.join(",") + "]";
      var buttonLabel = "Add Bundle to Cart (" + buttonTextArray.join(" + ") + ")";

      outputDiv.innerHTML = `
        <div class="result-highlight">You need: ${totalOz} oz (by weight)</div>
        <div class="recommendation-box">
          <span class="rec-title">Best Combination to Buy:</span>
          <button class="buy-btn-ajax" onclick="addBundleToCart(${itemsString}, this)">${buttonLabel}</button>
        </div>
        ${noteText}
      `;

      analyticsTimer = setTimeout(function() {
        if (typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent('Jacks Magic Fiber', type, sqftVal);
      }, 2000);
    }
  }

  typeSelect.addEventListener('change', calculateFiberDosage);
  sqftInput.addEventListener('input', calculateFiberDosage);
});


// ==========================================
// WIDGET 2: US Seal Compatibility Finder
// ==========================================
document.addEventListener("DOMContentLoaded", function() {
  var container = document.getElementById("us-seal-compatibility-target");
  if (!container) return;

  var sealData = {
    "Acura Spa Systems, Inc.": [
      { model: "Aquaheat / Aquaheal Plus", mfgNo: "1090-A", basic: "PS-601", premier: "PS-3986" },
      { model: "Magnaflow / Magnaflow 56", mfgNo: "1090-A", basic: "PS-601", premier: "PS-3986" }
    ],
    "American Products (Pentair)": [
      { model: "Americana", mfgNo: "395005", basic: "PS-201", premier: "PS-3868" },
      { model: "Americana II", mfgNo: "397012", basic: "PS-1000", premier: "PS-3865R" },
      { model: "Eagle", mfgNo: "397012, 397020", basic: "PS-1000", premier: "PS-3865R" }
    ],
    "Gecko Alliance (Aqua Flo)": [
      { model: "Flo-Master CP/HP", mfgNo: "92500150", basic: "PS-200", premier: "PS-3867" },
      { model: "Flo-Master XP2 / XP2E", mfgNo: "92500150, 92500151", basic: "PS-200", premier: "PS-3867" },
      { model: "Tub-Master", mfgNo: "91049000, 92500150", basic: "PS-2131", premier: "PS-3869" }
    ],
    "Hayward Industries": [
      { model: "Super Pump", mfgNo: "SPX1600Z2, SPX2605X7A", basic: "PS-201", premier: "PS-3868" },
      { model: "MaxFlo (SP2800X Series)", mfgNo: "SPX1600Z2", basic: "PS-201", premier: "PS-3868" },
      { model: "North Star", mfgNo: "SPX4000SAV", basic: "PS-3890", premier: "PS-4280" },
      { model: "TriStar / TriStar VS", mfgNo: "SPX3200SA", basic: "PS-3890", premier: "PS-4280" }
    ],
    "Jacuzzi": [
      { model: "Magnum", mfgNo: "10-1502-09", basic: "PS-200", premier: "PS-3867" },
      { model: "Vector", mfgNo: "10-0002-06", basic: "PS-200", premier: "PS-3867" }
    ],
    "Jandy (Zodiac)": [
      { model: "Stealth (New Style)", mfgNo: "R0479400", basic: "PS-3890", premier: "PS-4280" },
      { model: "Stealth (Old Style)", mfgNo: "R0445500", basic: "PS-3890", premier: "PS-4280" },
      { model: "ePump Variable Speed", mfgNo: "R0479400", basic: "PS-3890", premier: "PS-4280" }
    ],
    "Pentair Pool Products": [
      { model: "Whisperflo", mfgNo: "071734S", basic: "PS-1000", premier: "PS-3865R" },
      { model: "IntelliFlo", mfgNo: "071734S", basic: "PS-1000", premier: "PS-3865R" },
      { model: "Challenger", mfgNo: "354545", basic: "PS-200", premier: "PS-3867" },
      { model: "SuperFlo", mfgNo: "354545S", basic: "PS-200", premier: "PS-3867" }
    ],
    "Sta-Rite (Pentair)": [
      { model: "Dura-Glas / Dura-Glas II", mfgNo: "37400-0027S", basic: "PS-200", premier: "PS-3867" },
      { model: "Max-E-Glas", mfgNo: "37400-0027S", basic: "PS-200", premier: "PS-3867" },
      { model: "Max-E-Pro", mfgNo: "17351-0101S", basic: "PS-200", premier: "PS-3867" },
      { model: "Dyna-Glas / Dyna-Max", mfgNo: "U109-358SS", basic: "PS-201", premier: "PS-201V-CMS" }
    ],
    "Waterway Plastics": [
      { model: "Executive 48 & 56 Frame", mfgNo: "319-3100", basic: "PS-1000", premier: "PS-3865R" },
      { model: "Champion 56-Frame", mfgNo: "319-3100", basic: "PS-1000", premier: "PS-3865R" },
      { model: "Iron Might (2013-Present)", mfgNo: "319-3010", basic: "PS-1000", premier: "PS-3865R" }
    ]
  };

  var tooltipText = {
    basic: "Buna Elastomers, Molded Plastic Primary Ring, Ceramic Seat. Best for standard residential pools.",
    premier: "Viton® Elastomers, Carbon Primary Ring, Polished Ceramic Seat. High resistance to chemicals/heat."
  };

  var widgetHTML = `
    <style>
      #us-seal-widget { font-family: inherit; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 20px; margin: 20px 0; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }
      #us-seal-widget h3 { margin-top: 0; font-size: 1.25rem; margin-bottom: 5px; color: #111827; }
      #us-seal-widget p.subtext { font-size: 0.9rem; color: #6b7280; margin-bottom: 15px; }
      .us-seal-input-group { display: flex; flex-direction: column; gap: 15px; margin-bottom: 15px; }
      .us-seal-control { padding: 10px; border: 1px solid #ccc; border-radius: 4px; font-size: 1rem; width: 100%; box-sizing: border-box; background-color: #fff; cursor: pointer; }
      .us-seal-control:disabled { background: #e5e7eb; cursor: not-allowed; color: #9ca3af; }
      #us-seal-mfg-info { display: none; margin-bottom: 20px; background: #eff6ff; padding: 12px; border-left: 4px solid #3b82f6; border-radius: 4px; }
      #us-seal-mfg-info strong { color: #1e3a8a; display: block; margin-bottom: 4px; font-size: 0.95rem; }
      #us-seal-mfg-info span { color: #1e40af; font-size: 1.05rem; font-weight: bold; }
      #us-seal-results-container { display: none; }
      .us-seal-results-label { font-size: 1rem; font-weight: 600; color: #374151; margin-bottom: 15px; text-align: center; }
      #us-seal-results { display: flex; gap: 10px; flex-wrap: wrap; justify-content: center; }
      .us-seal-card { flex: 1; min-width: 150px; max-width: 250px; background: #fff; border: 1px solid #e5e7eb; border-radius: 6px; padding: 15px; text-align: center; transition: transform 0.2s, box-shadow 0.2s; position: relative; cursor: pointer; text-decoration: none; color: inherit; display: block; }
      .us-seal-card:hover { transform: translateY(-3px); box-shadow: 0 4px 12px rgba(0,0,0,0.1); border-color: #3b82f6; }
      .us-seal-badge { display: inline-block; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.5px; padding: 3px 6px; border-radius: 4px; margin-bottom: 10px; font-weight: bold; }
      .badge-basic { background: #e0e7ff; color: #3730a3; }
      .badge-premier { background: #fef3c7; color: #92400e; }
      .us-seal-sku { font-size: 1.25rem; font-weight: bold; color: #1f2937; margin: 0; }
      .us-seal-card .us-seal-tooltip { visibility: hidden; width: 200px; background-color: #1f2937; color: #fff; text-align: center; border-radius: 6px; padding: 8px; position: absolute; z-index: 20; bottom: 110%; left: 50%; transform: translateX(-50%); opacity: 0; transition: opacity 0.3s; font-size: 0.8rem; font-weight: normal; line-height: 1.4; }
      .us-seal-card .us-seal-tooltip::after { content: ""; position: absolute; top: 100%; left: 50%; margin-left: -5px; border-width: 5px; border-style: solid; border-color: #1f2937 transparent transparent transparent; }
      .us-seal-card:hover .us-seal-tooltip { visibility: visible; opacity: 1; }
    </style>

    <div id="us-seal-widget">
      <h3>Find Your Pump Shaft Seal</h3>
      <p class="subtext">Select your pump manufacturer and model to see compatible US Seal replacements.</p>
      
      <div class="us-seal-input-group">
        <select id="us-seal-mfg" class="us-seal-control"><option value="" disabled selected>Select Pump Manufacturer...</option></select>
        <select id="us-seal-model" class="us-seal-control" disabled><option value="" disabled selected>Select Pump Model...</option></select>
      </div>
      <div id="us-seal-mfg-info"><strong>These are the compatible Pump Model Numbers (Mfg. No.):</strong><span id="us-seal-mfg-numbers"></span></div>
      <div id="us-seal-results-container"><div class="us-seal-results-label">These U.S. Seal shaft seals fit the above manufacturer and model's.</div><div id="us-seal-results"></div></div>
    </div>
  `;

  container.innerHTML = widgetHTML;

  var mfgSelect = document.getElementById("us-seal-mfg");
  var modelSelect = document.getElementById("us-seal-model");
  var mfgInfoBox = document.getElementById("us-seal-mfg-info");
  var mfgNumbersDisplay = document.getElementById("us-seal-mfg-numbers");
  var resultsWrapper = document.getElementById("us-seal-results-container");
  var resultsContainer = document.getElementById("us-seal-results");
  var activeMfgData = [];

  Object.keys(sealData).forEach(function(mfg) {
    var option = document.createElement("option"); option.value = mfg; option.textContent = mfg; mfgSelect.appendChild(option);
  });

  mfgSelect.addEventListener("change", function(e) {
    var selectedMfg = e.target.value;
    activeMfgData = sealData[selectedMfg] || [];
    modelSelect.innerHTML = '<option value="" disabled selected>Select Pump Model...</option>';
    modelSelect.disabled = false;
    
    activeMfgData.forEach(function(item, index) {
      var option = document.createElement("option"); option.value = index; option.textContent = item.model; modelSelect.appendChild(option);
    });

    mfgInfoBox.style.display = "none";
    resultsWrapper.style.display = "none";

    if (typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent("US_Seal_Compatibility", "Mfg_Select", selectedMfg);
  });

  modelSelect.addEventListener("change", function(e) {
    var selectedIndex = e.target.value;
    var matchObj = activeMfgData[selectedIndex];
    if (!matchObj) return;

    if (typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent("US_Seal_Compatibility", "Model_Select", matchObj.model);

    mfgNumbersDisplay.textContent = matchObj.mfgNo || "N/A";
    mfgInfoBox.style.display = "block";
    resultsContainer.innerHTML = "";
    
    var seals = [
      { type: "Basic Service", sku: matchObj.basic, badgeClass: "badge-basic", tip: tooltipText.basic },
      { type: "Premier Viton", sku: matchObj.premier, badgeClass: "badge-premier", tip: tooltipText.premier }
    ];

    seals.forEach(function(seal) {
      if(!seal.sku) return; 
      var searchUrl = "https://poolaroo.com/search?q=" + encodeURIComponent(seal.sku) + "&options%5Bprefix%5D=last&filter.v.availability=1";
      var card = document.createElement("a");
      card.href = searchUrl; card.target = "_blank"; card.className = "us-seal-card";
      card.innerHTML = `<span class="us-seal-badge ${seal.badgeClass}">${seal.type}</span><p class="us-seal-sku">${seal.sku}</p><div class="us-seal-tooltip">${seal.tip}</div>`;
      
      card.addEventListener("click", function() {
        if (typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent("US_Seal_Compatibility", "Link_Click", seal.sku);
      });
      resultsContainer.appendChild(card);
    });
    resultsWrapper.style.display = "block";
  });
});

// ==========================================
// WIDGET 3: Unicel Cartridge Finder
// ==========================================
(function() {
    'use strict';
    
    const compatibilityData = {
        "Hayward": {
            "Star-Clear C1000": { oem_part: "CX1000RE", unicel_sku: "C-7470", shopify_handle: "unicel-filter-cartridge-80-sf-clean-clear-c-7470", specs: {filter_area: 75, length: "20\"", diameter: "7\"", pleats: 170} },
            "Star-Clear Plus C1200": { oem_part: "CX1200RE", unicel_sku: "C-8412", shopify_handle: "unicel-filter-cartridge-120-sf-cx1200-re-waterway-pro-clean-c-8412", specs: {filter_area: 120, length: "23.3\"", diameter: "8.9\"", pleats: 194} },
            "Easy Clear C400": { oem_part: "CX410RE", unicel_sku: "C-7456", shopify_handle: "unicel-56-sq-ft-hayward-cx481xre-rep-c-7456", specs: {filter_area: 40, length: "13.5\"", diameter: "7\"", pleats: 146} }
        },
        "Pentair": {
            "Clean & Clear Plus (160340)": { oem_part: "160340", unicel_sku: "C-7470", shopify_handle: "unicel-filter-cartridge-80-sf-clean-clear-c-7470", specs: {filter_area: 75, length: "20\"", diameter: "7\"", pleats: 170} },
            "Clean & Clear Plus (160317)": { oem_part: "160317", unicel_sku: "C-7471", shopify_handle: "unicel-filter-cartridge-105-sf-clean-clear-c-7471", specs: {filter_area: 105, length: "26\"", diameter: "7\"", pleats: 168} },
            "Predator 100": { oem_part: "160332", unicel_sku: "C-9699", shopify_handle: "unicel-filter-cartridge-100-sf-jacuzzi-cfr-100-c-9699", specs: {filter_area: 100, length: "19.9\"", diameter: "9.9\"", pleats: 194} }
        },
        "Waterway": {
            "Crystal Water 50": { oem_part: "817-0050", unicel_sku: "C-4950", shopify_handle: "unicel-filter-cartridge-50-sf-rainbow-in-line-c-4950", specs: {filter_area: 50, length: "13.3\"", diameter: "4.9\"", pleats: 212} },
            "Top Load 40": { oem_part: "817-0040", unicel_sku: "4CH-940", shopify_handle: "unicel-filter-cartridge-40-sf-4ch-940", specs: {filter_area: 40, length: "15\"", diameter: "4.6\"", pleats: 176} }
        },
        "Sta-Rite": {
            "System 3 Modular (S7M120)": { oem_part: "25021-0200", unicel_sku: "UHD-SR100", shopify_handle: "unicel-filter-cartridge-102-sf-sta-rite-uhd-sr100", specs: {filter_area: 102, length: "25.7\"", diameter: "8.7\"", pleats: 195} }
        },
        "Jacuzzi": {
            "CFR-100": { oem_part: "42-3598-08-R", unicel_sku: "C-9699", shopify_handle: "unicel-filter-cartridge-100-sf-jacuzzi-cfr-100-c-9699", specs: {filter_area: 100, length: "19.9\"", diameter: "9.9\"", pleats: 194} }
        }
    };

    const widgetStyles = `
        <style>
        .unicel-widget { max-width: 600px; margin: 20px 0; padding: 20px; border: 2px solid #0090D9; border-radius: 8px; background: #f8f9fa; font-family: Arial, sans-serif; }
        .unicel-widget h3 { color: #0090D9; margin-top: 0; text-align: center; }
        .unicel-widget label { font-weight: bold; margin-bottom: 5px; display: block; color: #333; }
        .unicel-widget select { width: 100%; padding: 10px; margin-bottom: 15px; border: 1px solid #ddd; border-radius: 4px; font-size: 16px; }
        .unicel-result { background: white; border: 1px solid #60D394; border-radius: 6px; padding: 20px; margin-top: 20px; animation: fadeIn 0.5s ease-in; }
        .unicel-result h4 { color: #60D394; margin-top: 0; }
        .unicel-specs { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin: 15px 0; background: #f8f9fa; padding: 15px; border-radius: 4px; }
        .unicel-specs div { font-size: 14px; }
        .unicel-specs strong { color: #0090D9; }
        .unicel-button { background: #0090D9; color: white !important; padding: 12px 24px; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; text-decoration: none; display: inline-block; transition: all 0.3s ease; margin-top: 15px; }
        .unicel-button:hover { background: #007BC1; transform: translateY(-2px); box-shadow: 0 4px 8px rgba(0,0,0,0.2); color: white !important; }
        .unicel-measurement-note { background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px; padding: 15px; margin: 15px 0; font-size: 14px; }
        .unicel-disclaimer { font-size: 12px; color: #666; border-top: 1px solid #ddd; padding-top: 15px; margin-top: 20px; text-align: center; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .hidden { display: none; }
        </style>
    `;

    function initWidget() {
        const container = document.getElementById('unicel-compatibility-widget');
        if (!container) return;

        container.innerHTML = widgetStyles + `
            <div class="unicel-widget">
                <h3>Need Help Finding Cartridges That Fit Your Filter?</h3>
                <p>Select the filter equipment that needs new cartridges:</p>
                <label for="manufacturer-select">Filter Manufacturer:</label>
                <select id="manufacturer-select">
                    <option value="">-- Select Manufacturer --</option>
                    ${Object.keys(compatibilityData).map(mfg => `<option value="${mfg}">${mfg}</option>`).join('')}
                </select>
                <label for="model-select" class="hidden">Filter Model:</label>
                <select id="model-select" class="hidden"><option value="">-- Select Model --</option></select>
                <div id="compatibility-result"></div>
            </div>
        `;

        setupEventListeners();
    }

    function setupEventListeners() {
        const mfgSelect = document.getElementById('manufacturer-select');
        const modelSelect = document.getElementById('model-select');
        const resultDiv = document.getElementById('compatibility-result');

        mfgSelect.addEventListener('change', function() {
            const manufacturer = this.value;
            const modelLabel = document.querySelector('label[for="model-select"]');
            
            if (manufacturer) {
                modelSelect.classList.remove('hidden');
                modelLabel.classList.remove('hidden');
                const models = compatibilityData[manufacturer];
                modelSelect.innerHTML = '<option value="">-- Select Model --</option>' + Object.keys(models).map(model => `<option value="${model}">${model}</option>`).join('');
            } else {
                modelSelect.classList.add('hidden');
                modelLabel.classList.add('hidden');
                resultDiv.innerHTML = '';
            }

            if (typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent("Unicel_Compatibility", "Mfg_Select", manufacturer);
        });

        modelSelect.addEventListener('change', function() {
            const manufacturer = mfgSelect.value;
            const model = this.value;
            
            if (manufacturer && model) {
                showCompatibility(manufacturer, model);
                if (typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent("Unicel_Compatibility", "Model_Select", model);
            } else {
                resultDiv.innerHTML = '';
            }
        });
    }

    function showCompatibility(manufacturer, model) {
        const resultDiv = document.getElementById('compatibility-result');
        const data = compatibilityData[manufacturer][model];
        if (!data) return;
        const specs = data.specs;
        
        resultDiv.innerHTML = `
            <div class="unicel-result">
                <h4>✓ Compatible Unicel Replacement Found!</h4>
                <p><strong>Unicel Part Number:</strong> ${data.unicel_sku}</p>
                <p><strong>Replaces OEM Part:</strong> ${data.oem_part}</p>
                <div class="unicel-specs">
                    <div><strong>Filter Area:</strong> ${specs.filter_area} sq ft</div><div><strong>Length:</strong> ${specs.length}</div>
                    <div><strong>Diameter:</strong> ${specs.diameter}</div><div><strong>Pleat Count:</strong> ${specs.pleats}</div>
                </div>
                <div class="unicel-measurement-note"><strong>📏 Important:</strong> Always measure your existing filter cartridge before ordering. Compare the length and diameter shown above with your current filter to ensure proper fit.</div>
                <a href="https://poolaroo.com/products/${data.shopify_handle}" class="unicel-button" target="_blank" onclick="if(typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent('Unicel_Compatibility', 'Link_Click', '${data.unicel_sku}');">View Product & Order →</a>
            </div>
            <div class="unicel-disclaimer">Compatibility data is based on manufacturer specifications and industry cross-reference guides. Always verify dimensions before ordering. Manufacturer names and trademarks are property of their respective owners.<br><br><em>Data sourced from Unicel official compatibility database. Updated ${new Date().getFullYear()}.</em></div>
        `;
    }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initWidget); } 
    else { initWidget(); }
})();

// ==========================================
// WIDGET 4: Vinyl Works Fence Sizer
// ==========================================
document.addEventListener("DOMContentLoaded", function() {
  var container = document.getElementById("vinyl-fence-calc-target");
  if (!container) return;

  var widgetHTML = `
    <style>
      #fence-calc-widget { background-color: #f4f6f8; border: 1px solid #dcdcdc; border-radius: 8px; padding: 20px; margin: 20px 0; font-family: inherit; max-width: 550px; }
      #fence-calc-widget h3 { margin-top: 0; color: #003366; font-size: 1.25em; margin-bottom: 10px; }
      .fence-instructions { font-size: 0.9em; color: #444; margin-bottom: 20px; line-height: 1.5; background-color: #fff; padding: 12px; border-left: 4px solid #0088cc; border-radius: 4px; }
      .calc-form-group { margin-bottom: 15px; }
      .calc-form-group label { display: block; font-weight: bold; margin-bottom: 5px; color: #333; }
      .calc-form-group select, .calc-form-group input { width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; font-size: 1em; }
      #calc-results-box { background-color: #fff; border-left: 6px solid #0088cc; padding: 15px; margin-top: 15px; display: none; box-shadow: 0 2px 5px rgba(0,0,0,0.05); }
      .result-highlight { font-weight: bold; color: #003366; font-size: 1.1em; margin-bottom: 10px; border-bottom: 1px solid #eee; padding-bottom: 8px; }
      .recommendation-box { background-color: #eef9ff; padding: 12px; border-radius: 5px; margin-bottom: 10px; }
      .rec-title { font-weight: bold; color: #d63031; margin-bottom: 8px; display: block; }
      .buy-link { display: block; background-color: #0088cc; color: white !important; text-decoration: none; padding: 10px 15px; border-radius: 4px; font-size: 0.95em; margin-bottom: 8px; font-weight: bold; text-align: center; transition: background-color 0.2s; }
      .buy-link:hover { background-color: #005f8f; }
      .result-note { font-size: 0.85em; color: #555; margin-top: 10px; line-height: 1.4; font-style: italic; }
    </style>

    <div id="fence-calc-widget">
      <h3>Need to figure out how much you need?</h3>
      <div class="fence-instructions">
        <strong>How to measure:</strong> Count the number of top rails you want to cover between the pool's support posts (each section spans up to 64.5 inches). 
        <br><br><em>Note: You only need to order coverage for open areas. If part of your pool touches a deck, do not include those sections.</em>
      </div>
      <div class="calc-form-group">
        <label for="fence-color">Choose your Fence Color:</label>
        <select id="fence-color"><option value="">-- Select Color --</option><option value="white">White</option><option value="taupe">Taupe</option></select>
      </div>
      <div class="calc-form-group" id="sections-group" style="display:none;">
        <label for="fence-sections">Total Sections to Cover:</label>
        <input type="number" id="fence-sections" placeholder="e.g. 10" min="1">
      </div>
      <div id="calc-results-box"><div id="calc-output-text"></div></div>
    </div>
  `;

  container.innerHTML = widgetHTML;

  var links = {
    white: { a: "https://poolaroo.com/products/vinyl-works-premium-24-fence-kit-a-8-section-base-white-a24p8-w", b: "https://poolaroo.com/products/vinyl-works-premium-24-fence-kit-b-3-section-add-on-white-b24p3-w", c: "https://poolaroo.com/products/vinyl_works_premium_2_section_fence_addon_white_c24p2-w" },
    taupe: { a: "https://poolaroo.com/products/vinyl-works-premium-24-8-section-base-fence-kit-a-taupe-a24p8-t", b: "https://poolaroo.com/products/vinyl-works-premium-24-3-section-fence-add-on-kit-b-taupe-b24p3-t", c: "https://poolaroo.com/products/vinyl-works-premium-24-2-section-fence-add-on-kit-c-taupe-c24p2-t" }
  };

  var colorSelect = document.getElementById('fence-color');
  var sectionInput = document.getElementById('fence-sections');
  var analyticsTimer;

  function calculateFence() {
    var color = colorSelect.value;
    var sections = parseInt(sectionInput.value);
    var sectionsGroup = document.getElementById('sections-group');
    var resultBox = document.getElementById('calc-results-box');
    var outputDiv = document.getElementById('calc-output-text');

    resultBox.style.display = 'none';
    sectionsGroup.style.display = color ? 'block' : 'none';
    clearTimeout(analyticsTimer);

    if (!color || isNaN(sections) || sections <= 0) return;

    var aKits = 1, bKits = 0, cKits = 0, rem = sections - 8;

    if (rem > 0) {
      if (rem === 1 || rem === 2) { cKits = 1; } 
      else if (rem >= 3) {
        if (rem % 3 === 0) { bKits = rem / 3; } 
        else if (rem % 3 === 1) { bKits = (rem - 4) / 3; cKits = 2; } 
        else if (rem % 3 === 2) { bKits = (rem - 2) / 3; cKits = 1; }
      }
    }

    var totalCoverage = (aKits * 8) + (bKits * 3) + (cKits * 2);
    var buttonsHtml = "";
    var skus = links[color];

    if (aKits > 0) buttonsHtml += "<a href='" + skus.a + "' class='buy-link' target='_blank'>Buy " + aKits + "x Base Kit A (8-Section) &rarr;</a>";
    if (bKits > 0) buttonsHtml += "<a href='" + skus.b + "' class='buy-link' target='_blank'>Buy " + bKits + "x Add-On Kit B (3-Section) &rarr;</a>";
    if (cKits > 0) buttonsHtml += "<a href='" + skus.c + "' class='buy-link' target='_blank'>Buy " + cKits + "x Add-On Kit C (2-Section) &rarr;</a>";

    var coverageNote = (totalCoverage > sections) ? "<p class='result-note'>Note: Package combinations are packaged to exceed requirements slightly. You will have " + (totalCoverage - sections) + " extra section(s).</p>" : "";

    outputDiv.innerHTML = "<div class='result-highlight'>Required Coverage: " + sections + " Sections</div><div class='recommendation-box'><span class='rec-title'>Exact Kits to Order:</span>" + buttonsHtml + "</div>" + coverageNote;
    resultBox.style.display = 'block';

    analyticsTimer = setTimeout(function() {
      if (typeof window.sendAnalyticsEvent === 'function') window.sendAnalyticsEvent('Vinyl Works Fence', 'Calculated', sections);
    }, 2000);
  }

  colorSelect.addEventListener('change', calculateFence);
  sectionInput.addEventListener('input', calculateFence);
});

// ==========================================
// GLOBAL HELPER FUNCTIONS
// (Accessible by all widgets)
// ==========================================

// 1. AJAX Cart Adding Function
window.addBundleToCart = function(itemsArray, btnElement) {
  var originalText = btnElement.innerHTML;
  btnElement.innerHTML = "Adding to Cart...";
  btnElement.disabled = true;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: itemsArray })
  })
  .then(response => {
    if (!response.ok) throw new Error('Network response was not ok');
    return response.json();
  })
  .then(data => {
    // Success State
    btnElement.innerHTML = "✓ Added to Cart!";
    btnElement.classList.add("buy-btn-success");
  })
  .catch((error) => {
    console.error('Error:', error);
    btnElement.innerHTML = "Error. Try Again.";
    btnElement.disabled = false;
  });
};

// 2. GA4 Analytics Tracking
window.sendAnalyticsEvent = function(toolName, filterType, inputValue) {
  // Check if gtag exists (Standard Shopify setup)
  if (typeof gtag === 'function') {
    gtag('event', 'use_calculator', {
      'tool_name': toolName,
      'filter_type': filterType,
      'input_value': inputValue
    });
    console.log("GA4 Event Sent: " + toolName + " | " + filterType);
  } 
  // Fallback: Check if dataLayer exists (GTM setup)
  else if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'use_calculator',
      'tool_name': toolName,
      'filter_type': filterType,
      'input_value': inputValue
    });
    console.log("DataLayer Event Pushed: " + toolName + " | " + filterType);
  }
};